/* Aurélys Paris — theme.js */
(function () {
  'use strict';

  // ----- Drawer + Search overlay -----
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-drawer-open]');
    if (openBtn) {
      var t = document.getElementById(openBtn.getAttribute('data-drawer-open'));
      if (t) { t.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    }
    var closeBtn = e.target.closest('[data-drawer-close]');
    if (closeBtn) {
      var p = closeBtn.closest('.drawer, .search-overlay');
      if (p) { p.classList.remove('is-open'); document.body.style.overflow = ''; }
    }
    if (e.target.classList && (e.target.classList.contains('drawer') || e.target.classList.contains('search-overlay'))) {
      e.target.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.drawer.is-open, .search-overlay.is-open').forEach(function (el) {
        el.classList.remove('is-open');
      });
      document.body.style.overflow = '';
    }
  });

  // ----- FAQ accordion -----
  document.querySelectorAll('.faq__item').forEach(function (item) {
    var btn = item.querySelector('.faq__q');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var expanded = item.getAttribute('aria-expanded') === 'true';
      item.setAttribute('aria-expanded', String(!expanded));
    });
  });

  // ----- Product gallery thumbs -----
  document.querySelectorAll('[data-product-gallery]').forEach(function (root) {
    var main = root.querySelector('[data-gallery-main] img');
    root.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-src');
        if (main && src) main.src = src;
        root.querySelectorAll('[data-gallery-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  });

  // ----- Variant selector: update price & availability via variant JSON -----
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var form = root.querySelector('form');
    if (!form) return;
    var dataEl = document.getElementById(root.getAttribute('data-variants-id'));
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var priceEl = document.querySelector('[data-product-price]');
    var submit = form.querySelector('[data-product-submit]');
    var idInput = form.querySelector('[name="id"]');

    function selectedOptions() {
      return Array.from(form.querySelectorAll('[data-option-selector]')).map(function (s) { return s.value; });
    }
    function findVariant() {
      var opts = selectedOptions();
      if (!opts.length) return variants[0];
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function update() {
      var v = findVariant();
      if (!v) {
        submit.disabled = true;
        submit.textContent = root.getAttribute('data-unavailable') || 'Unavailable';
        return;
      }
      idInput.value = v.id;
      if (priceEl) {
        var html = formatMoney(v.price);
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html = '<s>' + formatMoney(v.compare_at_price) + '</s> ' + html;
        }
        priceEl.innerHTML = html;
      }
      submit.disabled = !v.available;
      submit.textContent = v.available
        ? (root.getAttribute('data-add') || 'Add to cart')
        : (root.getAttribute('data-soldout') || 'Sold out');
    }
    form.querySelectorAll('[data-option-selector]').forEach(function (s) {
      s.addEventListener('change', update);
    });
    update();
  });

  function formatMoney(cents) {
    var format = (window.Shopify && window.Shopify.money_format) || '€{{amount}}';
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return format.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/, amount);
  }

  // ----- Quantity buttons -----
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var input = (minus || plus).closest('.product__qty, .cart__row').querySelector('input[type="number"]');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    if (minus) v = Math.max(1, v - 1);
    if (plus) v = v + 1;
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ----- Predictive search (basic) -----
  var searchInput = document.querySelector('[data-search-input]');
  var searchResults = document.querySelector('[data-search-results]');
  if (searchInput && searchResults) {
    var t;
    searchInput.addEventListener('input', function () {
      clearTimeout(t);
      var q = searchInput.value.trim();
      if (!q) { searchResults.innerHTML = ''; return; }
      t = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var items = (data.resources && data.resources.results && data.resources.results.products) || [];
            searchResults.innerHTML = items.map(function (p) {
              return '<li><a href="' + p.url + '"><span>' + p.title + '</span><span class="font-mono">' + p.price + '</span></a></li>';
            }).join('') || '<li class="eyebrow">Aucun résultat</li>';
          });
      }, 200);
    });
  }
})();
